import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import CopyToClipboard from '../../../../components/CopyToClipboard';
import { urlWebsite } from '../../../../config';
import { FaLink } from 'react-icons/fa';
import { FiCopy, FiMail } from 'react-icons/fi';
import api from '../../../../services/api';
import { useToast } from '../../../../hooks/Toast';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}


const Dashboard: React.FC = () => {
  const endpoint = '/speakers_terms_response';
  const title = 'Termos enviados';

  const { addToast } = useToast();
  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
    event_id: { ref: 'event_id', column: 'event_id', label: 'Evento', show: false },
    term_id: { ref: 'term_id', column: 'term_id', label: 'Hash', show: false },
    term_title: { ref: 'term_title', column: 'term_title', label: 'Termo' },
    hash: { ref: 'hash', column: 'hash', label: 'Hash', show: false },
    name: { ref: 'name', column: 'name', label: 'Nome' },
    email: { ref: 'email', column: 'email', label: 'E-mail' },
    document_number: { ref: 'document_number', column: 'document_number', label: 'CPF' },
    status: { ref: 'status', column: 'status', label: 'Status do Aceite' },
    approvedAt: {
      ref: 'ApprovedAt',
      column: 'ApprovedAt',
      label: 'Assinado em',
      mask: 'date',
    },
    cancelledAt: {
      ref: 'cancelledAt',
      column: 'cancelledAt',
      label: 'Assinado em',
      mask: 'date',
    },
    createdAt: {
      ref: 'createdAt',
      column: 'createdAt',
      label: 'Criado em',
      mask: 'date',
    },
  };




  const formSchema = {
    name: { model: 'input', type: 'text', name: 'name', label: 'Nome' },
    email: { model: 'input', type: 'text', name: 'email', label: 'E-mail' },
    document_number: { model: 'input', type: 'text', name: 'document_number', label: 'CPF' },
    term_id: {
      alias: 'term_id',
      model: 'selectApi',
      name: 'term_id',
      label: 'SpeakersTerm',
      endpoint,
    },
    speaker_id: {
      alias: 'speaker_id',
      model: 'selectApi',
      name: 'speaker_id',
      label: 'Speaker',
      endpoint,
    },
    language: {
      model: 'selectSimple',
      name: 'language',
      label: 'Idioma',
      defaultValue: 'ptBR',
      options: [
        { label: 'Português', value: 'ptBr' },
        { label: 'Inglês', value: 'en' },
        { label: 'Espanhol', value: 'es' },
      ],

    },
    allow_update: {
      model: 'selectSimple',
      name: 'allow_update',
      label: 'Permitir atualização?',
      defaultValue: 'Permitir Atualização?',
      options: [
        { label: 'Sim', value: 'Sim' },
        { label: 'Não', value: 'Não' },


      ],
    },
  };

  const formSchemaUpdate = {
    status: {
      model: 'selectSimple',
      name: 'status',
      label: 'O palestrante irá participar?',


      options: [
        { label: 'Aguardando confirmação', value: 'Aguardando confirmação' },
        { label: 'Sim', value: 'Sim' },
        { label: 'Não', value: 'Não' },


      ],
    },
    ...formSchema
  };

  const formValidation: Record<string, ValidationSchema> = {
    title: {
      name: 'name',
      type: 'string',
      label: 'Título',
      rules: [{ type: 'required' }],
    },
  };

  const sendMail = async (hash) => {

    try {
      await api.post(`/terms-send-invite/${hash}`);
      addToast({ type: 'success', title: 'Enviado' });
      return;
    }
    catch (err) {
      addToast({ type: 'error', title: 'Erro ao enviar' });
      return;
    }
  }

  const config: ISearchComponent = {
    idKey: endpoint,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [

      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
      (lineData: Record<string, any>) => {
        return <button className="lineIcon" title="Copiar link do termo"><CopyToClipboard Icon={FiCopy} text={`${urlWebsite}/app/${lineData?.project_id}/speaker-invitation/${lineData?.hash}`} /></button>


      },
      (lineData: Record<string, any>) => {
        return <button className="lineIcon" title="Enviar termo por email" type="button" onClick={() => sendMail(lineData.hash)}>
          <FiMail />
        </button>

      },
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default Dashboard;
